import { defineMessages } from 'react-intl';

export const surveyMessages = defineMessages({
	header_title: {
		id: 'survey.header.title',
		defaultMessage: 'Survey',
		description: 'Title text placed in header of the survey frame',
	},
	header_description: {
		id: 'survey.header.description',
		defaultMessage: 'Please share your opinion with us',
		description: 'Description text placed in header of the survey frame',
	},
	summary_title: {
		id: 'survey.header.title.complete',
		defaultMessage: 'Thanks for shared your opinion with us',
		description: 'Title text placed in header of survey accordion',
	},
	invalid_configuration: {
		id: 'survey.invalid_configuration',
		defaultMessage: 'Invalid Survey configuration',
		description:
			'This text appears when a user reach survey page even if this is not enabled/had configured',
	},
});
